/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Button, Col, Row} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import PpdeHeader from './components/ppde-header/PpdeHeader';
import A from '../../components/a/A';

import usePpdeMDHooks from './ppdeMDHooks';


const PpdeMD: React.FC = () => {
    const {
        memberInfo
    } = usePpdeMDHooks();

    const hasLink = !!(memberInfo.githubLink || memberInfo.aiStudioLink || memberInfo.personalHomePage);

    return (
        <div className="page paddle-ppdemd-page">
            <Header />
            <PpdeHeader />
            <div className="paddle-ppdemd-page-background">
                <div className="paddle-ppdemd-page-container">
                    <div className="paddle-ppdemd-item clear-both">
                        <div className="paddle-ppdemd-left">
                            <div className="paddle-ppdemd-img-wrap">
                                {!!memberInfo?.img
                                && (
                                    <div
                                        className="paddle-ppdemd-img"
                                        style={{backgroundImage: `url(${memberInfo.img})`}}
                                    >
                                        <img alt={memberInfo?.title} src={memberInfo.img} />
                                    </div>
                                )}
                            </div>
                            <div className="paddle-ppdemd-certificate-title" />
                            <div
                                className="paddle-ppdemd-certificate"
                                style={{height: memberInfo.certificate ? 'auto' : undefined}}
                            >
                                {!!memberInfo.certificate
                                && (
                                    <img
                                        alt="荣誉证书"
                                        src={memberInfo.certificate}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="paddle-ppdemd-info">
                            <div className="paddle-ppdemd-title">
                                {memberInfo?.title}
                                <span className="paddle-ppdemd-subtitle">{memberInfo?.subtitle}</span>
                            </div>
                            {hasLink
                            && (
                                <div className="paddle-ppdemd-homepage-link-wrap">
                                    {!!memberInfo.githubLink
                                    && (
                                        <A
                                            className="paddle-ppdemd-homepage-link"
                                            href={memberInfo.githubLink}
                                            target
                                        >
                                            <Button
                                                className="paddle-ppdemd-homepage-link-btn"
                                                ghost
                                                shape="round"
                                            >
                                                <i
                                                    className="paddle-ppdemd-homepage-link-btn-icon paddle-ppdemd-homepage-link-btn-icon-github"
                                                />
                                                Github主页
                                            </Button>
                                        </A>
                                    )}
                                    {!!memberInfo.aiStudioLink
                                    && (
                                        <A
                                            className="paddle-ppdemd-homepage-link"
                                            href={memberInfo.aiStudioLink}
                                            target
                                        >
                                            <Button
                                                className="paddle-ppdemd-homepage-link-btn"
                                                ghost
                                                shape="round"
                                            >
                                                <i
                                                    className="paddle-ppdemd-homepage-link-btn-icon paddle-ppdemd-homepage-link-btn-icon-aistudio"
                                                />
                                                Ai Studio主页
                                            </Button>
                                        </A>
                                    )}
                                    {!!memberInfo.personalHomePage
                                    && (
                                        <A
                                            className="paddle-ppdemd-homepage-link"
                                            href={memberInfo.personalHomePage}
                                            target
                                        >
                                            <Button
                                                className="paddle-ppdemd-homepage-link-btn"
                                                ghost
                                                shape="round"
                                            >
                                                <i
                                                    className="paddle-ppdemd-homepage-link-btn-icon paddle-ppdemd-homepage-link-btn-icon-personal"
                                                />
                                                个人主页
                                            </Button>
                                        </A>
                                    )}
                                </div>
                            )}
                            <div className="paddle-ppdemd-sub">
                                <Row gutter={[10, 10]}>
                                    <Col xs={12}>
                                        <div className="paddle-ppdemd-sub-label">
                                            职位：
                                        </div>
                                        {memberInfo?.position}
                                    </Col>
                                    <Col xs={12}>
                                        <div className="paddle-ppdemd-sub-label">
                                            授予时间：
                                        </div>
                                        {memberInfo?.entryTime}
                                    </Col>
                                    <Col xs={12}>
                                        <div className="paddle-ppdemd-sub-label">
                                            公司：
                                        </div>
                                        {memberInfo?.company}
                                    </Col>
                                    <Col xs={12}>
                                        <div className="paddle-ppdemd-sub-label">
                                            擅长领域：
                                        </div>
                                        {memberInfo?.goodField}
                                    </Col>
                                </Row>
                            </div>
                            <div className="paddle-ppdemd-line" />
                            <div className="paddle-ppdemd-sub">
                                <div className="paddle-ppdemd-title-h2">
                                    <i className="paddle-ppdemd-title-h2-icon paddle-ppdemd-works-icon" />
                                    开源代表作
                                </div>
                                <div className="paddle-ppdemd-works-wrap">
                                    <ul>
                                        {memberInfo?.works?.map((item, index) => (
                                            <li key={index}>
                                                <A
                                                    className="paddle-ppdemd-works-link"
                                                    key={index}
                                                    href={item.link}
                                                    target
                                                >
                                                    {item.text}
                                                </A>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="paddle-ppdemd-line" />
                            {!!memberInfo?.text
                            && (
                                <div className="paddle-ppdemd-sub">
                                    <div className="paddle-ppdemd-title-h2">
                                        <i className="paddle-ppdemd-title-h2-icon paddle-ppdemd-project-info-icon" />
                                        项目信息
                                    </div>
                                    <div
                                        className="paddle-ppdemd-text"
                                        dangerouslySetInnerHTML={{__html: memberInfo.text}}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PpdeMD;
